import { createSlice } from '@reduxjs/toolkit';
import { Service } from 'services/Services';
import { RequestApi } from 'RequestApi';
import { NotificationMessage } from 'components/notification-message/NotificationMessage';
import { setProgressingDocument, setViewingDocument, updateDocument } from 'components/dynamic/dynamic-page/DynamicPageSlice';

const initialState = {
  formLoading: false,
  record: null,
  pageInfo: null,
  showRemarkActionApproval: false,
  hostClusterName: '',
  loadingInsertRecordWorkflow: false,
};

const salaryCertificateRequestFormDocumentFormSlice = createSlice({
  name: 'salaryCertificateRequestFormDocumentForm',
  initialState,
  reducers: {
    setPageInfo(state, action) {
      state.pageInfo = action.payload;
    },
    setProgressing(state, action) {
      state.progressing = action.payload;
    },
    setFormLoading(state, action) {
      state.formLoading = action.payload;
    },
    setRecord(state, action) {
      state.record = action.payload;
    },
    setShowRemarkActionApproval(state, action) {
      state.showRemarkActionApproval = action.payload;
    },
    setHostClusterName(state, action) {
      state.hostClusterName = action.payload;
    },
    setWorkflowRequestType(state, action) {
      state.workflowRequestType = action.payload;
    },
    setLoadingInsertRecordWorkflow(state, action) {
      state.loadingInsertRecordWorkflow = action.payload;
    },
  },
});

const { setPageInfo, setFormLoading, setProgressing, setHostClusterName, setWorkflowRequestType, setLoadingInsertRecordWorkflow } =
  salaryCertificateRequestFormDocumentFormSlice.actions;

export const { setRecord, setShowRemarkActionApproval } = salaryCertificateRequestFormDocumentFormSlice.actions;

export const initPageInfo =
  ({ informationPage, document }) =>
  async (dispatch) => {
    try {
      dispatch(setFormLoading(true));
      dispatch(setPageInfo(informationPage));

      let url = `${informationPage.url}/index-card?`;
      url += `auth_token=${Service.userToken}`;

      const data = JSON.stringify({
        data_unid: document.id,
      });

      RequestApi(url, {
        data,
      })
        .then((res) => {
          if (res.data.status === 'success') {
            dispatch(setRecord(res.data.record));
            dispatch(setHostClusterName(res.data.host_cluster_name));
            dispatch(setWorkflowRequestType(res.data.workflow_request_types));

            if (!document.status) {
              dispatch(setViewingDocument(res.data.record));
            }
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }

          dispatch(setFormLoading(false));
        })
        .catch((err) => {
          console.log(err);
          dispatch(setFormLoading(false));
          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      dispatch(setFormLoading(false));
      NotificationMessage({ message: ex.toString(), status: 'error' });
    }
  };

export const updateRecord =
  ({ url, unid, fieldName, valueChanged, record }) =>
  async (dispatch) => {
    try {
      dispatch(setProgressingDocument(true));

      let urlRequest = `${url}/update-record?`;
      urlRequest += `auth_token=${Service.userToken}`;
      urlRequest += '&source_type=portal';

      const data = JSON.stringify({
        field_name: fieldName,
        value: valueChanged,
        unid,
      });

      RequestApi(urlRequest, {
        data,
      })
        .then((res) => {
          if (res.data.status === 'success') {
            const resRecord = res.data.record;
            const fieldNames = Object.keys(resRecord);
            const tmpRecord = { ...record };

            fieldNames.forEach((objFieldName) => {
              tmpRecord[objFieldName] = resRecord[objFieldName];
            });
            dispatch(setRecord(tmpRecord));
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }
          dispatch(setProgressingDocument(false));
        })
        .catch((err) => {
          dispatch(setProgressingDocument(false));
          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      dispatch(setProgressingDocument(false));
      NotificationMessage({ message: ex.toString(), status: 'error' });
    }
  };

export const updateWorkFlowCommittee =
  ({ url, unid, username, stepType, record }) =>
  async (dispatch) => {
    try {
      dispatch(setProgressingDocument(true));
      dispatch(setProgressing(true));

      let urlRequest = `${url}/update-record-workflow?`;
      urlRequest += `auth_token=${Service.userToken}`;
      urlRequest += '&source_type=portal';

      const data = JSON.stringify({
        username,
        step_type: stepType,
        unid,
        sub_unid: 0,
      });

      RequestApi(urlRequest, {
        data,
      })
        .then((res) => {
          if (res.data.status === 'success') {
            const resRecord = res.data.record;
            const fieldNames = Object.keys(resRecord);
            const tmpRecord = { ...record };

            fieldNames.forEach((objFieldName) => {
              tmpRecord[objFieldName] = resRecord[objFieldName];
            });

            dispatch(setRecord(tmpRecord));
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }
          dispatch(setProgressingDocument(false));
          dispatch(setProgressing(false));
        })
        .catch((err) => {
          dispatch(setProgressingDocument(false));
          dispatch(setProgressing(false));
          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      dispatch(setProgressingDocument(false));
      dispatch(setProgressing(false));
      NotificationMessage({ message: ex.toString(), status: 'error' });
    }
  };

export const deleteWorkFlowCommittee =
  ({ url, unid, subUnid, record }) =>
  async (dispatch) => {
    try {
      dispatch(setProgressingDocument(true));
      dispatch(setProgressing(true));

      let urlRequest = `${url}/delete-record-workflow?`;
      urlRequest += `auth_token=${Service.userToken}`;
      urlRequest += '&source_type=portal';
      const data = JSON.stringify({
        sub_unid: subUnid,
        unid,
      });

      RequestApi(urlRequest, {
        data,
      })
        .then((res) => {
          if (res.data.status === 'success') {
            const resRecord = res.data.record;
            const fieldNames = Object.keys(resRecord);
            const tmpRecord = { ...record };
            fieldNames.forEach((objFieldName) => {
              tmpRecord[objFieldName] = resRecord[objFieldName];
            });
            dispatch(setRecord(tmpRecord));
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }
          dispatch(setProgressingDocument(false));
          dispatch(setProgressing(false));
        })
        .catch((err) => {
          dispatch(setProgressingDocument(false));
          dispatch(setProgressing(false));
          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      dispatch(setProgressingDocument(false));
      dispatch(setProgressing(false));
      NotificationMessage({ message: ex.toString(), status: 'error' });
    }
  };

export const deleteAllRecordWorkflow =
  ({ url, unid, record }) =>
  async (dispatch) => {
    try {
      dispatch(setProgressingDocument(true));
      dispatch(setProgressing(true));

      let urlRequest = `${url}/delete-all-record-workflow?`;
      urlRequest += `auth_token=${Service.userToken}`;
      urlRequest += '&source_type=portal';

      const data = JSON.stringify({
        unid,
      });

      RequestApi(urlRequest, {
        data,
      })
        .then((res) => {
          if (res.data.status === 'success') {
            const resRecord = res.data.record;
            const fieldNames = Object.keys(resRecord);
            const tmpRecord = { ...record };

            fieldNames.forEach((objFieldName) => {
              tmpRecord[objFieldName] = resRecord[objFieldName];
            });

            dispatch(setRecord(tmpRecord));
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }
          dispatch(setProgressingDocument(false));
          dispatch(setProgressing(false));
        })
        .catch((err) => {
          dispatch(setProgressingDocument(false));
          dispatch(setProgressing(false));
          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      dispatch(setProgressingDocument(false));
      dispatch(setProgressing(false));
      NotificationMessage({ message: ex.toString(), status: 'error' });
    }
  };

export const insertRecordWorkflow =
  ({ url, unid, record }) =>
  async (dispatch) => {
    try {
      dispatch(setLoadingInsertRecordWorkflow(true));

      let urlRequest = `${url}/insert-record-workflow?`;
      urlRequest += `auth_token=${Service.userToken}`;
      urlRequest += '&source_type=portal';
      const data = JSON.stringify({
        unid,
        step_type: 'Check By',
      });
      RequestApi(urlRequest, {
        data,
      })
        .then((res) => {
          if (res.data.status === 'success') {
            const resRecord = res.data.record;
            const fieldNames = Object.keys(resRecord);
            const tmpRecord = { ...record };
            fieldNames.forEach((objFieldName) => {
              tmpRecord[objFieldName] = resRecord[objFieldName];
            });
            dispatch(setRecord(tmpRecord));
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }
          dispatch(setLoadingInsertRecordWorkflow(false));
        })
        .catch((err) => {
          dispatch(setLoadingInsertRecordWorkflow(false));
          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      dispatch(setLoadingInsertRecordWorkflow(false));
      NotificationMessage({ message: ex.toString(), status: 'error' });
    }
  };

export const updateLineWorkflowCommittee =
  ({ url, subUnid, unid, record, stepType, username }) =>
  async (dispatch) => {
    try {
      dispatch(setProgressingDocument(true));
      dispatch(setProgressing(true));

      let urlRequest = `${url}/change-record-workflow?`;
      urlRequest += `auth_token=${Service.userToken}`;
      urlRequest += '&source_type=portal';
      const data = JSON.stringify({
        unid,
        sub_unid: subUnid,
        step_type: stepType,
        username,
      });

      RequestApi(urlRequest, {
        data,
      })
        .then((res) => {
          if (res.data.status === 'success') {
            const resRecord = res.data.record;
            const fieldNames = Object.keys(resRecord);
            const tmpRecord = { ...record };
            fieldNames.forEach((objFieldName) => {
              tmpRecord[objFieldName] = resRecord[objFieldName];
            });
            dispatch(setRecord(tmpRecord));
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }
          dispatch(setProgressingDocument(false));
          dispatch(setProgressing(false));
        })
        .catch((err) => {
          dispatch(setProgressingDocument(false));
          dispatch(setProgressing(false));
          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      dispatch(setProgressingDocument(false));
      dispatch(setProgressing(false));
      NotificationMessage({ message: ex.toString(), status: 'error' });
    }
  };

export const actionApproval =
  ({ pageInfo, unid, dataApproval }) =>
  async (dispatch) => {
    try {
      dispatch(setProgressingDocument(true));

      let urlRequest = `/approval-workflow-activity/action-approval?`;
      urlRequest += `auth_token=${Service.userToken}`;
      urlRequest += '&source_type=portal';

      const data = JSON.stringify({
        unid,
        object_id: pageInfo.object_id,
        status: dataApproval.status,
        record_unid: dataApproval.activity.id,
        source: 'card',
      });

      RequestApi(urlRequest, { data })
        .then((res) => {
          if (res.data.status === 'success') {
            dispatch(setShowRemarkActionApproval(true));
            dispatch(setProgressingDocument(false));
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }
          dispatch(setProgressingDocument(false));
        })
        .catch((err) => {
          dispatch(setProgressingDocument(false));
          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      dispatch(setProgressingDocument(false));
      NotificationMessage({ message: ex.toString(), status: 'error' });
    }
  };

export const approvalWorkflowActivity =
  ({ pageInfo, unid, dataApproval, remark }) =>
  async (dispatch) => {
    try {
      dispatch(setProgressingDocument(true));

      const status = dataApproval.status.toString().toLowerCase();

      let token = '';
      let wfToken = '';

      if (status === 'accept') {
        const urlParams = new URLSearchParams(dataApproval.activity.accept_url);
        token = urlParams.get('token');
        wfToken = urlParams.get('wf_token');
      } else if (status === 'dispose') {
        const urlParams = new URLSearchParams(dataApproval.activity.dispose_url);
        token = urlParams.get('token');
        wfToken = urlParams.get('wf_token');
      } else if (status === 'return') {
        const urlParams = new URLSearchParams(dataApproval.activity.return_url);
        token = urlParams.get('token');
        wfToken = urlParams.get('wf_token');
      } else if (status === 'reject') {
        const urlParams = new URLSearchParams(dataApproval.activity.reject_url);
        token = urlParams.get('token');
        wfToken = urlParams.get('wf_token');
      }

      let urlRequest = `/approval-workflow-activity/${status}?`;
      urlRequest += `auth_token=${Service.userToken}`;
      urlRequest += '&source_type=portal';

      const data = JSON.stringify({
        unid,
        object_id: pageInfo.object_id,
        status: dataApproval.status,
        record_unid: dataApproval.activity.id,
        source: 'card',
        mail_content: remark,
        token,
        wf_token: wfToken,
      });

      RequestApi(urlRequest, { data })
        .then((res) => {
          if (res.data.status === 'success') {
            dispatch(setViewingDocument(res.data.record));
            dispatch(updateDocument(res.data.record));
            dispatch(setRecord(res.data.record));
            dispatch(setProgressingDocument(false));
            dispatch(setShowRemarkActionApproval(false));
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }
          dispatch(setProgressingDocument(false));
        })
        .catch((err) => {
          dispatch(setProgressingDocument(false));
          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      dispatch(setProgressingDocument(false));
      NotificationMessage({ message: ex.toString(), status: 'error' });
    }
  };

const salaryCertificateRequestFormDocumentFormReducer = salaryCertificateRequestFormDocumentFormSlice.reducer;

export default salaryCertificateRequestFormDocumentFormReducer;
